import { defineMessages } from 'react-intl';

export const ActionTypes = Object.freeze({
  SOURCE_CARD_OPENED: 'SOURCE_CARD_OPENED',
  SOURCE_CARD_OPTION_CLICKED: 'SOURCE_CARD_OPTION_CLICKED',
});

export const SourceCardCSSConstants = Object.freeze({
  SUBMENUSHIFT: '200%',
  OVERLAPSHIFT: '80%',
  UNIT: 'px',
  MENUWIDTH: 282,
  MAXSUBMENUHEIGHT: 268,
  LINEHEIGHT: 48,
  PADDING: { x: 18, y: 20 },
  FADETIMEOUT: 150,
  TUNERBARHEIGHT: 71, // actual height + 5px of spacing
  SUBMENUCLASSNAME: 'SourceCard__subMenu__item',
});

export const SourceCardConstants = Object.freeze({
  CLICK: 'click',
  CONTEXTMENU: 'contextmenu',
  DELETEPLAYLIST: 'deletePlaylist',
  ADDTOPLAYLIST: 'addToPlaylist',
  REMOVEFROMPLAYLIST: 'removeFromPlaylist',
  NEWPLAYLIST: 'newPlaylist',
  ADDTOCOLLECTION: 'addToCollection',
  REMOVEFROMCOLLECTION: 'removeFromCollection',
  OPENINDESKTOPAPP: 'openInDesktopApp',
  STARTSTATIONTRACK: 'startStationTrack',
  STARTSTATIONARTIST: 'startStationArtist',
  SCROLLTHRESHOLD: 10,
  DELETESTATION: 'deleteStation',
  SHARE: 'share',
  DELETE: 'delete',
  EDITSTATION: 'editStation',
  TIRED: 'tired',
  WHYSELECTED: 'whySelected',
});

export const SourceCardSubmenuComponents = Object.freeze({
  addToPlaylist: {
    component: 'AddToPlaylistSubmenu',
    domain: 'collection',
  },
});

export const SourceCardActionsDisabled = Object.freeze({
  [SourceCardConstants.ADDTOCOLLECTION]: {
    isUnavailable: true,
    isRadioOnly: true,
    isRetired: true,
  },
  [SourceCardConstants.REMOVEFROMCOLLECTION]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.NEWPLAYLIST]: {
    isUnavailable: true,
    isRadioOnly: true,
  },
  [SourceCardConstants.ADDTOPLAYLIST]: {
    isUnavailable: true,
    isRadioOnly: true,
  },
  [SourceCardConstants.REMOVEFROMPLAYLIST]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.STARTSTATIONTRACK]: {
    isUnavailable: true,
    isRadioOnly: false,
    hasNoRadio: true,
  },
  [SourceCardConstants.STARTSTATIONARTIST]: {
    isUnavailable: false,
    isRadioOnly: false,
    hasNoRadio: true,
  },
  [SourceCardConstants.SHARE]: {
    isUnavailable: true,
    isRadioOnly: false,
    isRetired: true,
  },
  [SourceCardConstants.DELETESTATION]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.DELETE]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.DELETEPLAYLIST]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.TIRED]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
  [SourceCardConstants.WHYSELECTED]: {
    isUnavailable: false,
    isRadioOnly: false,
  },
});

export const SourceCardItemsForNonPremium = {
  [SourceCardConstants.DELETEPLAYLIST]: false,
  [SourceCardConstants.ADDTOPLAYLIST]: false,
  [SourceCardConstants.REMOVEFROMPLAYLIST]: false,
  [SourceCardConstants.ADDTOCOLLECTION]: true,
  [SourceCardConstants.REMOVEFROMCOLLECTION]: true,
  [SourceCardConstants.OPENINDESKTOPAPP]: true,
  [SourceCardConstants.STARTSTATIONTRACK]: true,
  [SourceCardConstants.STARTSTATIONARTIST]: true,
  [SourceCardConstants.DELETESTATION]: true,
  [SourceCardConstants.SHARE]: true,
  [SourceCardConstants.DELETE]: true,
  [SourceCardConstants.EDITSTATION]: true,
  [SourceCardConstants.TIRED]: true,
  [SourceCardConstants.WHYSELECTED]: true,
};

export const SourceCardActionsMessages = defineMessages({
  addToCollection: {
    id: 't.addToCollection',
    defaultMessage: 'Collect',
  },
  removeFromCollection: {
    id: 't.removeFromCollection',
    defaultMessage: 'Remove from your collection',
  },
  newPlaylist: {
    id: 't.newPlaylist',
    defaultMessage: 'New Playlist',
  },
  addToPlaylist: {
    id: 't.addToPlaylist',
    defaultMessage: 'Add to Playlist',
  },
  removeFromPlaylist: {
    id: 't.removeFromPlaylist',
    defaultMessage: 'Remove from Playlist',
  },
  deletePlaylist: {
    id: 't.deletePlaylist',
    defaultMessage: 'Delete Playlist',
  },
  openInDesktopApp: {
    id: 't.openInDesktopApp',
    defaultMessage: 'Open in Desktop App',
  },
  createStation: {
    id: 't.createStation',
    defaultMessage: 'Create Station',
  },
  startStationArtist: {
    id: 't.createStationArtist',
    defaultMessage: 'Start Station from Artist',
  },
  startStationTrack: {
    id: 't.createStationTrack',
    defaultMessage: 'Start Station from Song',
  },
  deleteStation: {
    id: 't.deleteStation',
    defaultMessage: 'Delete Station',
  },
  editStation: {
    id: 't.editStation',
    defaultMessage: 'Edit Station',
  },
  share: {
    id: 't.share',
    defaultMessage: 'Share',
  },
  delete: {
    id: 't.delete',
    defaultMessage: 'Delete',
  },
  tired: {
    id: 't.tired',
    defaultMessage: "I'm Tired of This Song",
  },
  whySelected: {
    id: 't.whySelected',
    defaultMessage: 'Why This Song?',
  },
});

// the types of components that trigger sourcecards
export const SourceCardTriggerTypes = Object.freeze({
  ELLIPSIS_TRIGGER: 'ellipsisTrigger',
  STATION_TRIGGER: 'stationTrigger',
});
